import { Redirect, Route } from 'wouter';
import { AppLayout } from '../Pages/AppLayout/AppLayout';

const Protected = ({component: Component, ...rest}) => {
  const isLogged = true;

  return (
    !isLogged ? <Redirect to="/login" /> : 
    <AppLayout>
      <Route {...rest} component={Component} />
    </AppLayout>
  )   
}

export default Protected;
